/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";


import {
    LOAD_CITY,LOAD_STATE,LOAD_COUNTRY
} from "./constants";

import {
   loadCity,
    loadCitySuccess,
    loadCityError,
    loadState,
    loadStateSuccess,
    loadStateError,
    loadCountry,
    loadCountrySuccess,
    loadCountryError
} from "./actions";

import {
  loadCityDetails,
   loadStateDetails,
   loadCountryDetails
} from "./remotes";

function* loadCityDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CITY),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadCity(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadCityDetails, searchFilter);
        if (result) {
          yield put(loadCitySuccess(result.result));
        }
      } catch (error) {
        yield put(
          loadCityError(
            yield put(
              loadCityError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

function* loadStateDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_STATE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadState(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadStateDetails, searchFilter);
        if (result) {
          yield put(loadStateSuccess(result.result));
        }
      } catch (error) {
        yield put(
          loadStateError(
            yield put(
              loadStateError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}


function* loadCountryDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_COUNTRY),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadCountry(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadCountryDetails, searchFilter);
        if (result) {
          yield put(loadCountrySuccess(result.result));
        }
      } catch (error) {
        yield put(
        loadCountryError(
            yield put(
              loadCountryError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
     loadCityDetailsSaga(),
     loadStateDetailsSaga(),
     loadCountryDetailsSaga()

  ]);
}